import { defineMessages } from 'react-intl';

export default defineMessages({
  otherSearchesTitle: {
    id: 'global_notifications_manage_title_other',
    defaultMessage: 'Other email alerts',
  },
  trovitNewsletterTitle: {
    id: 'global_notifications_manage_text_newsletter_trovit',
    defaultMessage: 'Trovit newsletters',
  },
  trovitNewsletterSubtitle: {
    id: 'global_notifications_manage_subtext_newsletter_trovit',
    defaultMessage: 'Receive the best tips right in your inbox',
  },
  partnersNewsletterTitle: {
    id: 'global_notifications_manage_text_newsletter_partners',
    defaultMessage: 'Partners',
  },
  partnersNewsletterSubtitle: {
    id: 'global_notifications_manage_subtext_newsletter_partners',
    defaultMessage: 'Receive newsletters from websites recommended by Trovit',
  },
  notificationDeactivated: {
    id: 'global_notifications_manage_search_deactivate',
    defaultMessage: 'Alert deactivated',
  },
});



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/NewsletterNotifications/messages.js